import $ from 'jquery';
import Globals from '@/helpers/globals';

const { $body } = Globals;

const Form = {
    init() {
        $body.on('click', '.js-delivery_address', e => this.handleDeliveryAddress(e));
        $body.on('change', '.js-user-type', e => this.handleUserType(e));
        $body.on('focusin', '.form-control', e => this.handleLabelUp(e));
        $body.on('focusout', '.form-control', e => this.handleLabelDown(e));
        $body.on('keyup', '.js-confirm-password', e => this.confirmPassword(e));
        $body.on('submit', '.js-checkout-form', e => this.validateVat(e));

        this.setLabels();
    },

    validateVat(e) {
        const country = $('.js-invoice-country').val();
        const userType = $('.js-user-type:checked').val();

        if (userType !== 'business' || country !== 'NL') return;

        e.preventDefault();

        const $input = $('.js-checkout-vat');
        const value = $input.val();
        const regex = new RegExp('[a-zA-Z]{2}[0-9]{9}B[0-9]{2}');
        const message = $input.data('message');

        if (regex.test(value)) {
            $('.js-checkout-form')[0].submit();
        } else {
            window.Feedback.feedbackLoad({
                closeable: true,
                message,
            });
        }
    },

    confirmPassword(e) {
        const $curr = $(e.currentTarget);
        const $currForm = $curr.parents('form');

        if ($currForm.find('.js-password').val() !== $currForm.find('.js-password-confirm').val()) {
            $currForm.find('button').attr('disabled', true);
            $currForm.find('.js-confirm-message').removeClass('sr-only');
        } else {
            $currForm.find('button').attr('disabled', false);
            $currForm.find('.js-confirm-message').addClass('sr-only');
        }
    },

    handleDeliveryAddress(e) {
        const $curr = $(e.currentTarget);
        const $formHidden = $('.js-form-hidden');
        const showOtherDeliveryAddress = $curr.data('showOtherDeliveryAddress');

        $formHidden.find('[data-required]').each((index, input) => {
            $(input).prop('required', showOtherDeliveryAddress);
            $(input)[0].setCustomValidity('');

            if (!showOtherDeliveryAddress) $(input).removeAttr('required');
        });

        $formHidden.toggleClass('hidden', !showOtherDeliveryAddress);
    },

    handleLabelDown(e) {
        const $curr = $(e.currentTarget);
        if (!$curr.val()) $curr.parent().removeClass('active');
    },

    handleLabelUp(e) {
        const $curr = $(e.currentTarget);
        $curr.parent().addClass('active');
    },

    handleUserType(e) {
        const $curr = $(e.currentTarget);
        const userType = $curr.val();
        const businessElement = $('.js-form-group-business');

        if (userType === 'business') {
            businessElement.removeClass('hidden');
            businessElement.find('input').prop('required', true);

            if (businessElement.parents('.js-form-hidden').hasClass('hidden')) {
                businessElement.find('input').prop('required', false);
            }
        } else {
            businessElement.addClass('hidden');
            businessElement.find('input').prop('required', false);
        }
    },

    setLabels() {
        const $formControl = $('.form-control');

        $formControl.each((index, input) => {
            if ($(input).val().length) $(input).parent().addClass('active');
        });
    },
};

export default Form;
